<button [type]="type" color="primary" [disabled]="disabled" [class]="class" (click)="handleClick()">
  @if (!loading) {
  {{ caption }}
  } @else {
  <mat-spinner diameter="20" class="primary-spinner"></mat-spinner>
  }
</button>